/**
 * Whether someone born on `birthDate` (`YYYY-MM-DD`) is under 18 today.
 *
 * This only decides what the form shows. The Worker decides for real, from the
 * same date and the gym's own calendar day, and refuses a minor's request that
 * arrives without a guardian whatever this returned.
 */
export function isMinor(birthDate: string, today: Date = new Date()): boolean {
  const year = Number(birthDate.slice(0, 4))
  if (!Number.isFinite(year) || birthDate.length < 10) return false
  const pad = (n: number) => String(n).padStart(2, '0')
  const todayText = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`
  return todayText < `${year + 18}${birthDate.slice(4, 10)}`
}
